import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CollapsableContentBlock, StandardContentRowBlock, PlainContentModuleContainer } from "@silvertours/front-entities";
import { Tabs } from "../tabs";
import { TabContainer } from "./StandardContent.styles";
export var StandardContent = function(_param) {
    var rules = _param.rules, translations = _param.translations, content = _object_without_properties(_param, [
        "rules",
        "translations"
    ]);
    var ref = rules || {}, _allowCollapse = ref.allowCollapse, allowCollapse = _allowCollapse === void 0 ? true : _allowCollapse;
    return /*#__PURE__*/ _jsx(PlainContentModuleContainer, {
        children: /*#__PURE__*/ _jsx(CollapsableContentBlock, {
            content: content,
            translations: translations,
            rules: {
                allowCollapse: allowCollapse
            },
            children: function(param) {
                var module = param.module;
                switch(module.moduleType){
                    case "tabs":
                        return /*#__PURE__*/ _jsx(TabContainer, {
                            children: /*#__PURE__*/ _jsx(Tabs, _object_spread({}, module))
                        });
                    default:
                        return /*#__PURE__*/ _jsx(StandardContentRowBlock, {
                            content: module
                        });
                }
            }
        })
    });
};
